import { React, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAlert } from "../hooks/AlertHook";

export default function DevicesLayout() {
    const navigate = useNavigate()
    const alerta = useAlert();

    useEffect(() => {
        navigate(alerta.homeLink)
    }, [])

  return (
    <div>
    </div>
  );
}
